exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".address-form{padding:2rem 0 4rem;margin-left:-1.5rem}.address-form__cell{display:inline-block;width:100%;padding-left:1.5rem}.address-form__cell.cell-50{width:50%}.address-form__cell.cell-25{width:25%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-86ba0768!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddressForm.vue
// module id = 280
// module chunks = 0